module.exports = __webpack_public_path__ + "c56009709b606940cf381122a1e9a5cb.png";